import { useState, useContext, useEffect } from "react"
import { ApiService } from "../services/apiServices"
import { useNavigate } from "react-router-dom"
import LocationModal from "../Modals/location";
import DataContext from "../context";
import { toast } from "react-toastify"
const Header = () => {
  const contextValues = useContext(DataContext)
  const navigate = useNavigate();
  const [searchClick, setSearchClick] = useState(false)
  const [searchList, setSearchList] = useState([]);
  const [query, setQuery] = useState('')
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const onSearchClick = (e) => {
    setQuery('')
    setSearchClick(!searchClick);
    setSearchList([])
  };

  const onChangeInput = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    if (value.length > 2) {
      const timeout = setTimeout(() => {
        const dataString = {
          query: value,
        };
        ApiService.postData('get-search-data', dataString).then((res) => {
          if (res.status === 'success') {
            setSearchList(res.data);
          }
        });
      }, 500);
      setDebounceTimeout(timeout);
    } else {
      setSearchList([])
    }
  };

  const redirectSearchClick = (item) => {
    window.location.href = window.location.origin.toString() + '/search-result/' + query;
  }

  const onSearchBttnClick = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (query) {
        if (query.length >= 2) {
          setSearchClick(!searchClick);
          window.location.href = `/search-result/${query}`;
        } else {
          toast.error("Please type at least two characters for a better search");
        }
      } else {
        toast.error("Please type something here to search");
      }
    }
  };
  return (
    <>
      <div className="appHeader">
        <div className="left">
          <div className="hlocation">
            <div className="hlocation-content">
              <div class="d-flex align-items-center">
                <img loading="lazy" src={contextValues?.settingData?.logo ? contextValues.settingImageBaseUrl + contextValues?.settingData?.logo : '/img/logo.png'} alt="daadikitchen's logo" height={40} width={40}></img>
              </div>
            </div>
          </div>
        </div>
        <div className="right justify-content-end">
          <div className="button-group">
            <div className={`search-container ${searchClick ? 'is-hovered' : ''}`}>
              <button type="button" className="icon-button" onClick={() => { onSearchClick() }}><i class="ri-search-line"></i></button>
              <div className={`search-container-open ${!searchClick ? 'is-hidden' : ''}`}>
                <div className="container">
                  <form className="search" >
                    <input type="text" className="search-input input-empty" placeholder="What are you looking for?" id="search-input" value={query} onChange={(e) => { onChangeInput(e) }} onKeyDown={(e) => { onSearchBttnClick(e) }} />
                    <a href="javascript:void(0);" className="search-close" onClick={(e) => { onSearchClick(e) }}><i className="ri-close-line ri-xl"></i></a>
                  </form>
                </div>
                {searchClick && searchList && searchList.length > 0 &&
                  <ul>
                    {searchList?.map((item, index) => {
                      return (<>
                        <a href="javascript:void(0)" onClick={() => { redirectSearchClick(item) }}>
                          <li key={index} >{item?.product_name}</li>
                        </a>
                      </>)
                    })}
                  </ul>
                }
              </div>
            </div>
            <button type="button" className="icon-button" onClick={() => navigate('/choose-meal-date')}><i class="ri-shopping-cart-line"></i>{contextValues.cartCount && contextValues.cartCount > 0 ?
              <span className="count">{contextValues.cartCount}</span> : ''
            }</button>
          </div>
        </div>

      </div>
      {contextValues.toggleLocationModal && <LocationModal />}
    </>
  )
}
export default Header